import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { Calendar } from 'react-feather';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';
import { classNames } from '../../functions/classNames';
import './InputDate.css';
import 'moment/locale/it';
import 'react-datepicker/dist/react-datepicker.css';

const DATE_FORMAT = 'DD/MM/YYYY';
const DATE_REGEX = /\d{2}\/\d{2}\/\d{4}$/;

class InputDate extends Component {
  value = (value) => {
    if (!value || moment.isMoment(value)) {
      return value;
    }

    return moment(value);
  };

  handleChange = (date) => {
    const { handleChange, name } = this.props;

    handleChange({
      target: {
        name: name,
        value: date,
      },
    });
  };

  handleChangeRaw = (event) => {
    const newValue = event.target.value;

    if (!DATE_REGEX.test(newValue)) {
      this.handleChange(moment.invalid());
    }
  };

  validateInput = (event) => {
    const newValue = event.target.value;

    if (!DATE_REGEX.test(newValue)) {
      this.handleChange(null);
    }
  };

  render() {
    const { label, value, placeholder, error } = this.props;
    const { locale } = this.context;

    const selected = this.value(value);
    const selectedDate = selected && selected.isValid() ? selected : null;
    const selectedValue = selected ? selected : '';
    const placeholderText = placeholder ? placeholder : getLabel(locale, 'general.dateFormat');

    return (
      <div className={classNames('InputDate', error ? 'hasError' : '')}>
        <div className="input-label">{getLabel(locale, label)}</div>
        <div className="input-container">
          <DatePicker
              dateFormat={DATE_FORMAT}
              locale='it'
              value={selectedValue}
              selected={selectedDate}
              placeholderText={placeholderText}
              onChange={this.handleChange}
              onChangeRaw={this.handleChangeRaw}
              onBlur={this.validateInput}
          />
          <div className="icon">
            <Calendar />
          </div>
        </div>
      </div>
    );
  }
}

InputDate.contextTypes = {
  locale: PropTypes.string,
};

export default InputDate;



// WEBPACK FOOTER //
// ./src/main/components/input/InputDate.js